import { routes } from '../../helpers/routes.helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import LogoSvg from '../svg/logo-svg';
import WhatsappContactLink from '../link/whatsapp-contact-link';

export default function Navbar() {
	const isActive = (route: string) => {
		return window.location.pathname === route ? 'text-secondary' : '';
	}

	const navItems = (
		<div className={'flex-none'}>
			<ul className={'menu menu-horizontal space-x-10 items-center px-1 text-base-100'}>
				<li><a href={routes.home} className={isActive(routes.home)}>Home</a></li>
				<li><a href={routes.company} className={isActive(routes.company)}>A Empresa</a></li>
				<li><a href={routes.products} className={isActive(routes.products)}>Nossos produtos</a></li>
				<li><a href={routes.services} className={isActive(routes.services)}>Serviços</a></li>
				<li>
					<WhatsappContactLink>
						<button className={'btn btn-primary'}>Entre em contato</button>
					</WhatsappContactLink>
				</li>
			</ul>
		</div>
	);

	const drawer = (
		<div className="drawer">
			<input id="my-drawer" type="checkbox" className="drawer-toggle"/>
			<div className="drawer-content">
				<label htmlFor="my-drawer" className="drawer-button">
					<FontAwesomeIcon icon={faBars} size={'2x'} className={'text-base-100 cursor-pointer'}/>
				</label>
			</div>
			<div className="drawer-side cursor-default">
				<label htmlFor="my-drawer" aria-label="close sidebar" className="drawer-overlay cursor-default"></label>
				<ul className="menu bg-base-content text-base-100 min-h-full w-72 p-4 pt-8 space-y-1 cursor-default">
					<li>
						<div className={'w-full flex justify-start'}>
							<LogoSvg className={'h-12'}/>
						</div>
					</li>
					<li><a href={routes.home} className={isActive(routes.home)}>Home</a></li>
					<li><a href={routes.company} className={isActive(routes.company)}>A Empresa</a></li>
					<li><a href={routes.products} className={isActive(routes.products)}>Nossos produtos</a></li>
					<li><a href={routes.services} className={isActive(routes.services)}>Serviços</a></li>
					<li><WhatsappContactLink>Entre em contato</WhatsappContactLink></li>
				</ul>
			</div>
		</div>
	);

	return (
		<nav className={'w-full navbar bg-black px-6 text-base flex justify-between h-28 sm:h-20'}>
			<div className={'flex-1'}>
				<a href={routes.home} className={'cursor-pointer'}><LogoSvg className={'h-14'}/></a>
			</div>
			<div className={'hidden lg:flex'}>
				{navItems}
			</div>
			<div className={'flex lg:hidden'}>
				{drawer}
			</div>
		</nav>
	);
}